exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.upload-field-box__content {\n\tbackground-color: var(--wf-secondary);\n\tborder: 1px solid #bfbfbf;\n\tpadding: 10px;\n\tborder-radius: 10px;\n}\n", ""]);

// exports
